export default {
  // Navbar
  nav: {
    howItWorks: 'Hoe het werkt',
    newUpload: 'Nieuwe upload',
    signInSave: 'Log in om op te slaan',
    upload: 'Uploaden',
    files: 'Bestanden',
    account: 'Account',
    signOut: 'Uitloggen',
    pricing: 'Prijzen',
    legal: 'Juridisch',
    goToApp: 'Naar de app',
    signInGoogle: 'Inloggen met Google',
  },

  // Landing
  landing: {
    formatsTitle: 'Opent 70 bestandstypen',
    formatsLink: 'Alle formaten bekijken',
    eyebrow: '3D-viewer voor Revit, IFC, STEP en 70 bestandstypen',
    ctaUpload: 'Nieuwe upload',
    ctaNoAccount: 'Probeer het zonder account',
    viewerCaption: 'Live IFC-model · sleep om te draaien',
    heroTitle1: 'BIM-bestanden delen.',
    heroTitle2: 'Simpel en snel.',
    heroSubtitle: 'Open Revit, IFC, STEP, Tekla, Rhino, DXF, OBJ, FBX, STL en nog veel meer 3D-bestanden in je browser. Deel ze via een link of sluit de viewer in op je website.',
    heroFree: 'Gratis — 10 bestanden per maand',
    footerRights: 'Alle rechten voorbehouden.',
  },

  // Upload
  upload: {
    bundled: '{count} bestanden samengevoegd in {name}',
    bundleHint: 'Model met materialen of texturen (OBJ + MTL, DAE, 3DS…)? Sleep de hele map of een ZIP.',
    guestNotice: 'Gastmodus: maximaal {limit} bestanden. Log in om ze te bewaren en links te delen.',
    openViewer: 'Viewer openen',
    title: 'Bestanden uploaden',
    uploadsThisMonth: 'uploads deze maand',
    remaining: 'resterend',
    dragDrop: 'Sleep bestanden hierheen',
    orClick: 'of klik om te bladeren',
    formats: 'IFC, DWG, PDF, DXF, BCF, GLTF, GLB, OBJ, FBX, DAE, STL, 3MF, PLY, USDZ en elk ander bestandstype',
    limitReached: 'Maandlimiet bereikt',
    limitReachedDesc: 'Je hebt alle {limit} uploads van deze maand gebruikt.',
    upgradePro: 'Upgrade naar Pro →',
    uploading: 'Uploaden...',
    uploadComplete: 'Upload voltooid!',
    filesUploaded: '{count} bestand(en) geüpload.',
    viewMyFiles: 'Mijn bestanden bekijken',
    uploadMore: 'Meer uploaden',
    uploadFailed: 'Upload mislukt',
    tryAgain: 'Opnieuw proberen',
    limitError: 'Maandelijkse uploadlimiet bereikt. Upgrade naar Pro voor meer uploads.',
    partialUpload: 'Je kunt deze maand nog maar {max} bestand(en) uploaden. De eerste {max} worden geüpload.',
    fileTooLarge: '"{name}" is groter dan de limiet van {limit} per bestand voor je abonnement. Upgrade naar Pro voor grotere bestanden.',
  },

  // Files
  files: {
    title: 'Mijn bestanden',
    uploadFiles: 'Bestanden uploaden',
    loading: 'Je bestanden worden geladen...',
    noFiles: 'Nog geen bestanden',
    noFilesDesc: 'Upload je eerste bestand om te beginnen.',
  },

  // Account
  account: {
    title: 'Account',
    profile: 'Profiel',
    userId: 'Gebruikers-ID',
    authProvider: 'Inlogmethode',
    subscription: 'Abonnement',
    currentPlan: 'Huidig abonnement',
    monthlyLimit: 'Maandelijkse uploadlimiet',
    price: 'Prijs',
    free: 'Gratis',
    filesPerMonth: '{count} bestanden / maand',
    unlimited: 'Onbeperkt',
    freeForever: '€ 0 / voor altijd',
    custom: 'Op maat',
    viewPlans: 'Abonnementen bekijken en upgraden →',
    upgradeToPro: 'Upgrade naar Pro',
    manageSubscription: 'Abonnement beheren',
    processing: 'Verwerken...',
    usageTitle: 'Gebruik deze maand',
    filesUploaded: 'bestanden geüpload deze maand',
    unlimitedRemaining: 'Onbeperkt uploaden',
    uploadsRemaining: 'Nog {count} upload(s) over deze maand',
    limitReached: 'Maandlimiet bereikt. Wordt volgende maand gereset.',
    session: 'Sessie',
    signOutDesc: 'Log uit op dit apparaat.',
    signOut: 'Uitloggen',
  },

  // Account: Claude / MCP API keys
  mcp: {
    title: 'Claude (MCP)',
    serverUrl: 'URL van de MCP-server',
    desc: 'Gebruik BimDrop vanuit Claude: laat het bestanden uploaden, opsommen en deellinks maken.',
    keyName: 'Naam van de sleutel',
    keyNamePlaceholder: 'Naam van de sleutel, bv. Claude Code',
    create: 'Sleutel maken',
    newKeyWarning: 'Kopieer deze sleutel nu. Je ziet hem niet meer terug.',
    claudeCode: 'Claude Code',
    otherClients: 'Andere MCP-clients (JSON-configuratie)',
    copy: 'Kopiëren',
    copied: 'Gekopieerd',
    created: 'gemaakt op {date}',
    lastUsed: 'laatst gebruikt {date}',
    neverUsed: 'nooit gebruikt',
    revoke: 'Sleutel intrekken',
    revokeConfirm: '"{name}" intrekken? Claude verliest de toegang met deze sleutel.',
    error: 'Er ging iets mis. Probeer het opnieuw.',
    claudeApps: 'claude.ai en Claude Desktop',
    claudeAppsSteps: 'Ga naar Instellingen → Connectors → Aangepaste connector toevoegen, plak de URL hierboven en log in met Google.',
    claudeCodeSteps: 'Voer daarna /mcp uit in Claude Code en log in met Google.',
    connectedApps: 'Verbonden apps',
    connected: 'verbonden op {date}',
    disconnect: 'Loskoppelen',
    disconnectConfirm: '"{name}" loskoppelen? De app verliest de toegang tot je bestanden.',
    apiKeys: 'API-sleutels',
    apiKeysDesc: 'Voor scripts en MCP-clients zonder inloggen. Stuur de sleutel als "Authorization: Bearer …".',
  },

  // OAuth consent page (Claude connectors)
  oauth: {
    loading: 'Verzoek controleren…',
    invalid: 'Dit verbindingsverzoek is niet geldig',
    error: 'Er ging iets mis. Probeer het opnieuw.',
    title: '{app} toegang geven tot je BimDrop-account?',
    unverified: 'BimDrop heeft deze app niet geverifieerd. Ga alleen verder als je de app vertrouwt.',
    signInPrompt: 'Log in om verder te gaan.',
    signedInAs: 'Ingelogd als {email}.',
    switchAccount: 'Ander account gebruiken',
    permissionsTitle: 'De app kan:',
    permUpload: 'Bestanden naar je account uploaden',
    permList: 'Je bestanden en hun links bekijken',
    permShare: 'Deellinks maken en intrekken',
    redirectNote: 'Na toestemming ga je terug naar {host}.',
    allow: 'Toestaan',
    deny: 'Annuleren',
    redirecting: 'Terug naar {host}…',
  },

  // Viewer
  viewer: {
    loadingModel: '3D-model laden…',
    loadError: 'Model kon niet worden geladen',
    back: 'Terug',
    fitView: 'Alles in beeld',
    projection: 'Projectie',
    hideSelected: 'Geselecteerd element verbergen',
    isolateSelected: 'Geselecteerd element isoleren',
    showAll: 'Alle elementen tonen',
    share: 'Delen',
    loading: 'Bestandsgegevens laden...',
    processingBtlx: 'BTLx verwerken...',
    backToFiles: 'Terug naar bestanden',
    notPreviewable: 'Van dit bestandstype is geen voorbeeld beschikbaar.',
    btlxProcessing: 'Het 3D-model wordt gegenereerd. Wacht even en vernieuw de pagina.',
    btlxError: 'Verwerking mislukt. Het 3D-model kon niet worden gegenereerd.',
    btlxQueued: 'Het 3D-model staat in de wachtrij. Kom zo even terug.',
    parts: 'onderdelen',
    layers: 'lagen',
  },

  // Shared Viewer
  shared: {
    loading: 'Gedeeld model laden...',
    linkNotFound: 'Link niet gevonden',
    linkExpired: 'Deze gedeelde link bestaat niet of is verlopen.',
    goToBimdrop: 'Naar Bimdrop',
    sharedVia: 'Dit bestand is via Bimdrop met je gedeeld.',
    download: 'Downloaden',
    tryFree: 'Probeer Bimdrop gratis →',
    hideSelected: 'Selectie verbergen',
    isolateSelected: 'Selectie isoleren',
    showAll: 'Alles tonen',
  },

  // FileCard
  fileCard: {
    generating3D: '3D-model genereren...',
    processingFailed: 'Verwerking mislukt',
    queued: 'In de wachtrij',
    downloadTooltip: 'Downloaden',
    shareTooltip: 'Delen',
    editTooltip: 'Bewerken',
    deleteTooltip: 'Verwijderen',
    confirmDelete: 'Klik nogmaals om te bevestigen',
    confirm: 'Bevestigen?',
    view2D: '2D bekijken',
    view3D: '3D bekijken',
    fileName: 'Bestandsnaam',
    description: 'Beschrijving',
    descriptionPlaceholder: 'Voeg een beschrijving toe...',
    save: 'Opslaan',
    cancel: 'Annuleren',
  },

  // Share Modal
  shareModal: {
    shareTitle: '"{name}" delen',
    viewer: 'Viewer',
    embed: 'Insluiten',
    shareFile: 'Bestand delen',
    viewerDesc: 'Deel een viewerlink. Iedereen met deze link kan het bestand in de browser bekijken of downloaden — geen account nodig.',
    generatingLink: 'Beveiligde link maken...',
    tryAgain: 'Opnieuw proberen',
    copied: 'Gekopieerd!',
    copy: 'Kopiëren',
    recipientsCanView: 'Ontvangers kunnen het bestand direct bekijken of downloaden',
    email: 'E-mail',
    whatsapp: 'WhatsApp',
    embedDesc: 'Plak deze code in de HTML van je website om een interactieve viewer in te sluiten:',
    generatingEmbed: 'Insluitcode maken...',
    directLinkDesc: 'Kopieer de directe downloadlink of verstuur hem via e-mail / WhatsApp:',
  },

  // Guest (anonymous) sessions
  guest: {
    badge: 'Gast',
    saveTitle: 'Bewaar je bestanden',
    saveDesc: 'Je gebruikt een gastsessie. Log in met Google om je bestanden te bewaren en te delen.',
    shareLocked: 'Log in om te delen',
    shareLockedDesc: 'Voor openbare links en insluitcodes heb je een account nodig. Je geüploade bestanden gaan mee naar je account.',
    accountDesc: 'Gastsessie. Je bestanden gaan verloren als je je browsergegevens wist of uitlogt.',
  },

  // Theme toggle
  theme: {
    system: 'Thema: systeem',
    light: 'Thema: licht',
    dark: 'Thema: donker',
  },

  // Cookie Banner
  cookies: {
    message: 'We gebruiken cookies om je ervaring te verbeteren. Door Bimdrop te gebruiken, ga je akkoord met ons',
    cookiePolicy: 'cookiebeleid',
    accept: 'Accepteren',
  },

  // Pricing
  pricing: {
    title: 'Eenvoudige, transparante prijzen',
    subtitle: 'Begin gratis. Upgrade wanneer je meer nodig hebt.',
    free: 'Gratis',
    pro: 'Pro',
    enterprise: 'Enterprise',
    forever: 'voor altijd',
    perMonth: '/maand',
    freeDesc: 'Ideaal om mee te beginnen',
    proDesc: 'Voor professionals en kleine teams',
    enterpriseDesc: 'Voor organisaties met geavanceerde behoeften',
    getStarted: 'Aan de slag',
    comingSoon: 'Binnenkort',
    upgrade: 'Upgrade naar Pro',
    processing: 'Verwerken...',
    contactUs: 'Neem contact op',
    popular: 'Populair',
    // Features
    freeF1: '10 uploads per maand',
    freeF2: 'Delen via link, e-mail en WhatsApp',
    freeF3: 'Bestanden insluiten op websites',
    freeF4: 'Eenvoudig bestandsbeheer',
    freeF5: 'Max. 100 MB per bestand',
    proF1: '150 uploads per maand',
    proF2: 'Alles uit Gratis',
    proF3: 'Max. 1 GB per bestand',
    proF4: 'Eigen huisstijl in ingesloten viewers',
    proF5: 'Support met voorrang',
    proF6: 'Analyses en downloadstatistieken',
    entF1: 'Alles uit Pro',
    entF2: 'Onbeperkte bestandsgrootte',
    entF3: 'SSO en teambeheer',
    entF4: 'Eigen domein',
    entF5: 'SLA en dedicated support',
    entF6: 'API-toegang',
    home: 'Home',
    legalCookies: 'Juridisch & cookies',
  },

  // Legal
  legal: {
    title: 'Juridische informatie & cookiebeleid',
    lastUpdated: 'Laatst bijgewerkt: maart 2026',
  },

  // How it works page
  how: {
    fmtTekla: 'Tekla Structures 2020+-modellen: upload de modelmap als ZIP (bèta)',
    fmtFab: 'Productiebestanden: hout (BTLX) en stalen onderdelen (DSTV NC1)',
    exportTitle: 'Exporteer vanuit je software',
    exportNote: 'Menunamen verschillen iets per versie.',
    exportRevit1: 'Revit-projecten 2023–2025 openen direct: upload het .rvt-bestand (bèta).',
    exportRevit2: 'Voor het volledige model of andere versies: Bestand → Exporteren → IFC.',
    exportRevit3: 'Kies IFC4 Reference View of IFC 2x3 Coordination View 2.0 en upload het .ifc-bestand.',
    exportTekla1: 'Model: Bestand → Exporteren → IFC, exporttype “Coordination view”, en upload het .ifc-bestand.',
    exportTekla2: 'Productie: Productie → NC-bestanden (DSTV). Upload de .nc1-bestanden of een ZIP van de map.',
    exportTekla3: 'Elk NC1-bestand opent als stalen onderdeel met profiel, gaten en merk.',
    fmtRvt: 'Revit-projecten 2023–2025, omgezet in je browser (bèta)',
    fmtCad: 'Solid-CAD: samenstellingen met namen en kleuren',
    fmtMore: 'X, OFF, 3DS, PLY, VRML, CityJSON en meer. DWG en PDF worden opgeslagen om te downloaden.',
    eyebrow: 'Hoe het werkt',
    title: 'Van bestand naar deelbare link in drie stappen',
    subtitle: 'Sleep een BIM- of CAD-bestand erin, bekijk het in 3D in je browser en stuur een link. Geen plug-ins, niets te installeren.',
    s1Title: 'Sleep je bestand erin',
    s1Desc: 'Sleep een bestand naar het uploadvak of kies het op je computer. Je kunt het zonder account proberen.',
    s1P1: 'IFC, DXF, GLB, OBJ, FBX, DAE, STL, 3MF, USDZ, BTLX, DWG, PDF en meer',
    s1P2: 'Tot 100 MB met Gratis en 1 GB met Pro',
    s1P3: 'Geen account nodig voor je eerste bestanden',
    s2Title: 'Bekijk het in 3D',
    s2Desc: 'Het model opent direct in je browser. Draai eromheen, klik op een element om de eigenschappen te zien, verberg of isoleer onderdelen.',
    s2P1: 'IFC-attributen en property sets',
    s2P2: 'DXF-tekeningen in 2D, GLB, GLTF en STL in 3D',
    s2P3: 'BTLX-houtbestanden automatisch omgezet naar 3D',
    s3Title: 'Deel een link',
    s3Desc: 'Log in met Google voor een openbare link. Iedereen kan de viewer openen, zonder account.',
    s3P1: 'Kopieer de link of stuur hem via e-mail of WhatsApp',
    s3P2: 'Sluit de viewer in op je website met één codefragment',
    s3P3: 'Linkvoorbeelden tonen een miniatuur van je model',
    mockReady: 'Klaar',
    mockSelected: 'Geselecteerd',
    mockSite: 'Jouw website',
    accountsTitle: 'Met of zonder account',
    guestTitle: 'Zonder account',
    guestDesc: 'Ideaal om Bimdrop te proberen met je eigen bestand.',
    guestF1: '3 uploads tot 100 MB',
    guestF2: 'Bekijken in 3D en 2D',
    guestF3: 'Bestanden blijven alleen in deze browser',
    accountTitle: 'Met een gratis Google-account',
    accountDesc: 'Bewaar je bestanden en deel ze.',
    accountF1: '10 uploads per maand',
    accountF2: 'Openbare links en insluitingen',
    accountF3: 'Je bestanden op al je apparaten',
    formatsTitle: 'Ondersteunde formaten',
    fmtIfc: '3D-model met eigenschappen',
    fmtDxf: '2D-tekening, of 3D als er 3D-entiteiten in staan',
    fmtGlb: '3D-model, ook SketchUp- en 3D-printexports',
    fmtBtlx: 'Houtbewerkingsdata, omgezet naar 3D',
    fmtOther: 'Opgeslagen en gedeeld om te downloaden',
    ctaTitle: 'Probeer het met je eigen bestand',
  },

  // Viewer workspace (toolbar, panels, saved views)
  ws: {
    frame: 'Eenheden en oriëntatie',
    units: 'Eenheden van het model',
    upAxis: 'Verticale as',
    upY: 'Y omhoog',
    upZ: 'Z omhoog',
    toolSelect: 'Selecteren',
    toolMeasure: 'Meten',
    toolNote: 'Notitie toevoegen',
    toolClip: 'Doorsnede',
    fit: 'Alles in beeld',
    presets: 'Aanzichten',
    presetIso: 'Isometrisch',
    presetTop: 'Boven',
    presetFront: 'Voor',
    presetBack: 'Achter',
    presetLeft: 'Links',
    presetRight: 'Rechts',
    projection: 'Perspectief / orthografisch',
    walk: 'Loopmodus',
    walkHint: 'Sleep om rond te kijken · WASD of pijltjes om te lopen · Esc om te stoppen',
    hide: 'Verbergen',
    isolate: 'Isoleren',
    showAll: 'Alles tonen',
    color: 'Kleur',
    clearColors: 'Kleuren verwijderen',
    xray: 'Röntgen',
    screenshot: 'Screenshot',
    fullscreen: 'Volledig scherm',
    exitFullscreen: 'Volledig scherm sluiten',
    clipX: 'Doorsnede X',
    clipY: 'Doorsnede Y',
    clipZ: 'Doorsnede Z',
    clipFace: 'Klik op een vlak om te snijden',
    clipClear: 'Doorsneden verwijderen',
    panel: 'Paneel',
    panelModel: 'Model',
    panelCategories: 'Categorieën',
    panelLayers: 'Lagen',
    panelViews: 'Aanzichten',
    panelNotes: 'Notities',
    panelMeasures: 'Metingen',
    panelProperties: 'Eigenschappen',
    treeLoading: 'Structuur laden…',
    treeEmpty: 'Geen structuur beschikbaar',
    groupsEmpty: 'Niets om te tonen',
    viewsAdd: 'Huidig aanzicht opslaan',
    viewsNamePlaceholder: 'Naam van het aanzicht',
    viewsEmpty: 'Sla camerastandpunten op om wie de link opent te begeleiden.',
    viewDefaultName: 'Aanzicht {n}',
    notesEmpty: 'Gebruik de notitietool om opmerkingen op het model te prikken.',
    notePlaceholder: 'Schrijf een notitie…',
    noteAdd: 'Notitie toevoegen',
    cancel: 'Annuleren',
    delete: 'Verwijderen',
    edit: 'Bewerken',
    saveEdit: 'Opslaan',
    measuresEmpty: 'Gebruik de meettool en klik op twee punten.',
    measureClear: 'Alles wissen',
    measureHint: 'Klik op twee punten om te meten · Esc om te annuleren',
    noteHint: 'Klik op het model om een notitie te plaatsen',
    clipHint: 'Klik op een vlak voor een doorsnede · sleep de pijlen om hem te verplaatsen',
    selectionEmpty: 'Selecteer een element om de eigenschappen te zien',
    focus: 'Inzoomen',
    save: 'Aanzicht opslaan',
    saving: 'Opslaan…',
    saved: 'Aanzicht opgeslagen',
    saveError: 'Het aanzicht kon niet worden opgeslagen',
    tooBig: 'Dit aanzicht is te groot om op te slaan. Verwijder wat verborgen elementen of notities.',
    unsaved: 'Niet-opgeslagen wijzigingen',
    resetShared: 'Terug naar gedeeld aanzicht',
    discard: 'Wijzigingen verwerpen',
    ownerHint: 'Wat je hier opslaat, ziet iedereen die de link opent.',
    sharedBadge: 'Gedeeld aanzicht',
    shortcuts: 'Sneltoetsen',
    close: 'Sluiten',
    noteBy: 'Notitie',
    tour: 'Rondleiding',
  },

  // Revit files (rvt-rs)
  revit: {
    reading: 'Revit-bestand lezen…',
    converting: 'Revit-model omzetten naar IFC…',
    localHint: 'Omgezet in je browser: het bestand wordt nergens heen gestuurd.',
    unsupportedTitle: 'Dit Revit-bestand kan nog niet in 3D worden getoond',
    unsupportedDesc: 'Revit {version}, {kind}. De 3D-weergave werkt voor Revit-projecten uit 2023, 2024 en 2025.',
    exportHint: 'In Revit: Bestand → Exporteren → IFC, en upload het IFC-bestand hier voor het volledige model.',
    download: 'Origineel downloaden',
    error: 'Dit Revit-bestand kon niet worden gelezen',
    betaHint: 'In je browser omgezet vanuit Revit met rvt-rs. Sommige elementen zijn vereenvoudigd (deuren, ramen en meubels kunnen als blokken verschijnen).',
    kind_project: 'project',
    kind_family: 'familie',
    kind_template: 'sjabloon',
    kind_unknown: 'bestand',
  },

  // SEO
  seo: {
    howTitle: 'Hoe het werkt — BIM-bestanden uploaden, bekijken en delen',
    howDesc: 'Sleep een Revit-, IFC-, STEP-, DXF- of een van 70 andere 3D-bestanden erin, bekijk het in je browser en deel het via een link of insluiting. Zo werkt Bimdrop, stap voor stap.',
    landingTitle: 'Open en deel Revit, IFC, STEP en 3D-bestanden via een link',
    landingDesc:
      'Bimdrop opent Revit, IFC, STEP, IGES, Rhino, Tekla, DSTV, DXF, OBJ, FBX, glTF, STL en 70 bestandstypen in je browser, zonder iets te installeren. Deel ze via een link of sluit een interactieve 3D-viewer in.',
    pricingTitle: 'Prijzen — Gratis, Pro en Enterprise',
    pricingDesc:
      'Eenvoudige, transparante prijzen voor het delen van BIM-bestanden. Begin gratis met 10 uploads per maand. Upgrade naar Pro voor hogere limieten, grotere bestanden en statistieken.',
    legalTitle: 'Juridische informatie & cookiebeleid',
    legalDesc:
      'Juridische kennisgeving, gebruiksvoorwaarden en cookiebeleid van Bimdrop.',
  },
} as const
